import React, { Component } from 'react'
import { createStyles, WithStyles, withStyles, Paper, Typography, Breadcrumbs, Theme as MuiTheme } from '@material-ui/core'
import { RouteComponentProps, Switch, Route } from 'react-router';
import Books from './Books';
import { NavLink } from 'react-router-dom';
import Theme from '../../Resources/Theme';
import Chapters from './Chapters';
import Sections from './Sections';
import Exercise from './Exercise';

interface IProps extends WithStyles<typeof STYLES>, RouteComponentProps<any> { }

interface IState {
    breadcrumbsConfig: Array<{ url: string, label: string }>
}

class BooksSolutions extends Component<IProps, IState> {

    BreadcrumbsConfig = [

        {
            url: 'chapters',
            label: 'Chapter',
        },
        {
            url: 'sections',
            label: 'Sections'
        },
        {
            url: 'exercises',
            label: 'Exercises'
        }
    ]

    constructor(props: IProps) {
        super(props);
        this.state = {
            breadcrumbsConfig: [{
                url: 'books',
                label: 'Books'
            },]
        }
    }

    componentDidMount() {
        this.buildBreadCrumbs(this.props.history.location.pathname);
    }

    buildBreadCrumbs = (path: string) => {
        let pathVars = path.split('/');
        let breadCrumbs: Array<{ url: string, label: string }> = []
        pathVars.shift();
        if (pathVars[2] === 'books') {
            breadCrumbs.push({ url: 'books', label: 'Books' })
        }

        if (pathVars[4] === 'chapters') {
            breadCrumbs.push({ url: `dashboard/books/${pathVars[2]}/chapters`, label: 'Chapters' })
        }

        if (pathVars[6] === 'sections') {
            breadCrumbs.push({ url: `dashboard/books/${pathVars[2]}/chapters/${pathVars[4]}/sections`, label: 'Sections' })
        }

        if (pathVars[8] === 'exercises') {
            breadCrumbs.push({ url: `dashboard/books/${pathVars[2]}/chapters/${pathVars[4]}/sections/${pathVars[6]}/exercises`, label: 'Exercise' })
        }

        this.setState({ breadcrumbsConfig: breadCrumbs });
    }

    componentDidUpdate(nextProps: IProps) {
        if (this.props.location.pathname !== nextProps.location.pathname) {
            this.buildBreadCrumbs(nextProps.history.location.pathname);
        }
    }

    render() {
        const { classes } = this.props
        return (
            <div className={classes.root} >
                <div className={classes.breadcrumbsContainer} >
                    <Paper className={classes.paper} >
                        <Breadcrumbs separator='>' arial-label='Breadcrumbs'  >
                            {
                                this.state.breadcrumbsConfig.map((item, index) => {
                                    return (
                                        <NavLink
                                            key={index}
                                            to={`/dashboard/books-solutions/${item.url}`}
                                            activeClassName={classes.activeBreadcrumb}
                                            exact
                                        >
                                            <Typography variant='body2' >{item.label}</Typography>
                                        </NavLink>
                                    )
                                })
                            }
                        </Breadcrumbs>
                    </Paper>
                </div>
                <Switch>
                    <Route path={'/dashboard/books-solutions/books'} exact component={Books} />
                    <Route path={'/dashboard/books-solutions/books/:bookId/chapters'} exact component={Chapters} />
                    <Route path={'/dashboard/books-solutions/books/:bookId/chapters/:chapterId/sections'} exact component={Sections} />
                    <Route path={'/dashboard/books-solutions/books/:bookId/chapters/:chapterId/sections/:sectionId/exercises'} exact component={Exercise} />
                </Switch>
            </div>
        )
    }
}


const STYLES = (theme: MuiTheme) => createStyles({
    root: {
        height: '100%'
    },
    breadcrumbsContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: 20
    },
    paper: {
        padding: 12
    },
    activeBreadcrumb: {
        '& > p': {
            color: Theme.Colors.Secondary.main,
            fontWeight: 'bold'
        }
    }
})

export default (withStyles(STYLES)(BooksSolutions));